import { CSSProperties, FC, memo } from 'react'
import ReactCountryFlag from 'react-country-flag'

import { Box, SxProps, Theme } from '@mui/material'

import styles from './GRCountryFlag.module.scss'

type GRCountryFlagProps = {
  countryCode?: string
  title?: string
  size?: 'small' | 'medium' | 'large'
  className?: string
  style?: CSSProperties
  sx?: SxProps<Theme>
}

/**
 * Component for displaying a country flag
 */
export const GRCountryFlag: FC<GRCountryFlagProps> = memo(({ countryCode, title, size = 'medium', className, style, sx }) => {
  const flagClasses = `GRCountryFlag ${styles.root} ${styles[size]} ${className}`

  return (
    <Box component="span" sx={sx}>
      <ReactCountryFlag className={flagClasses} svg countryCode={countryCode?.toUpperCase() || 'us'} title={title} style={style} />
    </Box>
  )
})
